import { AbstractControl } from '@angular/forms';

export function containsLinkValidation(control: AbstractControl): {[key: string]: boolean} | null {
  const correct = control.value?.includes('{{ linkToInterview }}');
  return !correct ? {doesntContainLink: true} : null;
}
